import React from 'react';
import { Link } from 'react-router-dom';

const Logo = ({ size = 'md', showText = true, linkTo = '/' }) => {
  const sizes = {
    sm: { img: 'w-8 h-8', text: 'text-sm', subtext: 'text-[8px]' },
    md: { img: 'w-10 h-10', text: 'text-base', subtext: 'text-[10px]' },
    lg: { img: 'w-12 h-12', text: 'text-lg', subtext: 'text-xs' },
    xl: { img: 'w-16 h-16', text: 'text-xl', subtext: 'text-sm' },
  };

  const s = sizes[size] || sizes.md;

  const content = (
    <div className="flex items-center gap-3">
      <div className={`${s.img} rounded-lg overflow-hidden bg-white shadow-lg flex-shrink-0`}>
        <img 
          src="/logo.png" 
          alt="Anaconda-Deer Lodge Emergency Services" 
          className="w-full h-full object-contain"
        />
      </div>
      {showText && (
        <div>
          <h1 className={`font-headings font-bold uppercase tracking-wide ${s.text} text-white`}>
            Anaconda-Deer Lodge
          </h1>
          <p className={`text-zinc-400 uppercase tracking-widest ${s.subtext}`}>
            Emergency Services
          </p>
        </div>
      )}
    </div>
  );

  if (linkTo) {
    return (
      <Link to={linkTo} className="hover:opacity-90 transition-opacity">
        {content}
      </Link>
    );
  }

  return content;
};

export default Logo;
